import React from "react";
import { classNames } from "../../helpers/classNames";

const Card = ({ title, children, className, bodyClass }) => {
  return (
    <div
      className={classNames(
        "py-8 px-4 md:px-6 rounded-md space-y-4 border border-gray-200",
        className
      )}
    >
      {title && <h4 className="text-xl lg:text-2xl text-deep-purple font-bold font-Montserrat">{title}</h4>}
      <div className={bodyClass}>{children}</div>
    </div>
  );
};

export default Card;
